import Card from 'components/Card';
import DataItem from 'components/DataItem';
import { getStringValue, displayISODateTime } from 'shared/helpers/common';

export default function ExtrasItem({ extra = {}, isLoyaltyExtra }) {
  const { name, type, startDate, endDate } = extra;

  return (
    <Card cardTitle={getStringValue(name)}>
      <div className="flex flex-wrap pb-3">
        <DataItem label="Type" value={type} />
        {!isLoyaltyExtra && (
          <>
            <DataItem
              label="Start Date"
              value={displayISODateTime(startDate)}
            />
            <DataItem label="End Date" value={displayISODateTime(endDate)} />
          </>
        )}
      </div>
    </Card>
  );
}
